
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class BranchInGrid extends _Ext.GridBase<BranchInRow, any> {
        protected getColumnsKey() { return 'Inventory.BranchIn'; }
        protected getDialogType() { return BranchInDialog; }
        protected getIdProperty() { return BranchInRow.idProperty; }
        protected getInsertPermission() { return BranchInRow.insertPermission; }
        protected getLocalTextPrefix() { return BranchInRow.localTextPrefix; }
        protected getService() { return BranchInService.baseUrl; }
        rowSelection: Serenity.GridRowSelectionMixin;
        private autoSize;
        constructor(container: JQuery) {
            super(container); 
        }

        protected addButtonClick() {

            let now = new Date();
            var voucherNo = FormatHelper.GetVoucherNo(45);

            var userDefinition = Q.Authorization.userDefinition;
            var autoposting = OMS.VoucherMasterRow.getLookup().itemById[45].AutoPosting;
            this.editItem(<BranchInRow>{
                VoucherNo: voucherNo,
                Line_No: 0,
                CompanyId: userDefinition.CompanyId,
                FinancialYearId: userDefinition.FinancialYearId,
                UserId: userDefinition.UserId,
                CurrencyId: userDefinition.CurrencyId,
                TransDate: now.toDateString(),
                VoucherTypeId: 45,
                AutoPosting: autoposting

            });
        }
        protected onClick(e: JQueryEventObject, row: number, cell: number) {            
            var item = this.itemAt(row);
            super.onClick(e, row, cell);            
        }
        
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != "add-button");
            return buttons;
        }
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}